/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TreatmentAutomations/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import Automation from './Automation/index'
import AutomationsList from './AutomationsList/index'
import EnsureUrl from 'DesignSystem/EnsureUrl/react'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function TreatmentAutomations({
  children,
  viewPath = "/App/Account/Content/Settings/Content/TreatmentAutomations"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'AutomationsList'
  return (<React.Fragment
>
<EnsureUrl
  viewPath={`${viewPath}/EnsureUrl`}
/>
<fromFlow.When is={flowValue === 'AutomationsList'}>
<AutomationsList
  viewPath={`${viewPath}/AutomationsList`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Automation'}>
<Automation
  viewPath={`${viewPath}/Automation`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}